export enum EntityStoreName {
  Users = 'users',
  SearchUsers = 'search_users',
  Games = 'games',
  Matches = 'matches',
  GameSessions = 'game-sessions',
  Notifications = 'notifications',
  CurrentMatch = 'current_match',
  Modals = 'modals',
  Tournaments = 'tournaments',
  CurrentTournament = 'current_tournament',
  CurrentTournamentMatchGame = 'current_tournament_match_game',
  TournamentActivity = 'tournament_activity',
  TournamentBracket = 'tournament_bracket',
  ManageUsers = 'manage_users',
  ManageWithdraw = 'manage_withdraw',
  PlatformLinking = 'platform_linking',
  Wallet = 'wallet',
  UserPaymentAccounts = 'user_payment_accounts',
  ExchangeRates = 'exchange_rates',
  Transactions = 'transactions',
  Feedbacks = 'feedbacks',
  GameStatistics = 'game_statistics',
  AffiliatePrograms = 'affiliate_programs',
}
